/**
 * A frase que o servidor mandou explicando por que recusou.
 *
 * ## Por que isto existe
 *
 * Quando a API recusa uma gravação com 422, ela manda junto o motivo em
 * português -- "Não é possível finalizar o chamado do chat sem serviço e
 * categoria." O front jogava isso num `console.log` e **não mostrava nada**:
 * o cartão arrastado no kanban simplesmente não se movia, sem explicação.
 *
 * Esse silêncio é pior que o erro. Quem arrasta conclui que o kanban quebrou,
 * e a regra nova parece defeito.
 *
 * ## O formato não é um só
 *
 * O interceptor de `services/http` reempacota alguns status (403 vira
 * `responseData`) e deixa outros crus, do axios. Esta função lê os dois, mais
 * o caso em que a mensagem já veio como texto -- nenhuma tela precisa saber
 * qual dos três aconteceu.
 */

const textoUtil = (valor) => {
    const texto = String(valor ?? '').trim();

    return texto === '' ? null : texto;
};

/**
 * @param {*} erro  o que o `catch` recebeu
 * @returns {string|null} `null` quando não há mensagem do servidor, e aí quem
 *   chamou decide o que dizer -- inventar um texto genérico aqui esconderia a
 *   diferença entre "o servidor explicou" e "a rede caiu".
 */
export const mensagemDoErroDaApi = (erro) => {
    if (!erro) return null;

    if (typeof erro === 'string') return textoUtil(erro);

    return textoUtil(erro.response?.data?.message)
        || textoUtil(erro.responseData?.message)
        || textoUtil(erro.errorMessage?.message)
        || (typeof erro.errorMessage === 'string' ? textoUtil(erro.errorMessage) : null);
};
